export let config = {
    smartTVshow: true,
    liveChannelshow: true,
    title: '',
    mainDomain: '',
    language: '',
    vod: true,
    movies: false,
    lang: '',
    country: 'my'
};
let url = window.location.host;

if (url.indexOf('safaricom.bidiotv') >= 0 ) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    document.title = "BidioTV"
    config.language = 'english'
    config.vod = false
    config.subDomain = 'bidiotv'
    config.lang = 'en'
    config.country = 'za'
} else if (url.indexOf('safaricom.mobiotv') >= 0 ) { // only videos
    config.smartTVshow = true;
    config.liveChannelshow = true;
    config.title = 'safaricom';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = true
    config.subDomain = 'safaricom'
    config.lang = 'en'
    config.country = 'za'
} else if (url.indexOf('uk') >= 0 ) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'uk'
    config.movies = true
    config.lang = 'en'
    config.country = 'gb'
}else if (url.indexOf('za.fun-box') >= 0 || url.indexOf('local') >= 0 ) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'za.fun-box'
    config.newDomain = 'fun-box'
    config.movies = true
    config.lang = 'en'
    config.country = 'za'
}else if (url.indexOf('premium') >= 0) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'premium'
    config.movies = true
    config.lang = 'en'
    config.country = 'za'
} else if (url.indexOf('demo') >= 0 ) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'demo'
    config.movies = true
    config.lang = 'en'
    config.country = 'my'
} else if (url.indexOf('pt') >= 0) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'portuguese'
    config.vod = false
    config.subDomain = 'pt'
    config.movies = true
    config.lang = 'pt'
    config.country = 'pt'
} else if (url.indexOf('fitness-bay') >= 0) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'fitness-bay.mobiofit'
    config.newDomain = 'fitness-bay'
    config.movies = true
    config.lang = 'en'
    config.country = 'xx'
}  else if (url.indexOf('es.trendme') >= 0) {
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'spanish'
    config.vod = false
    config.subDomain = 'es.trendme'
    config.movies = true
    config.lang = 'es'
    config.newDomain = 'trendme'
    config.country = 'es'
}  else if (url.indexOf('za.fun-box') >= 0) {
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'za.fun-box'
    config.newDomain = 'fun-box'
    config.movies = true
    config.lang = 'en'
    config.country = 'za'    
} else if (url.indexOf('eu.flamilingo') >= 0) {
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'spanish'
    config.vod = false
    config.subDomain = 'eu.flamilingo'
    config.movies = true
    config.lang = 'es'
    config.newDomain = 'flamilingo'
    config.country = 'es'
} else if (url.indexOf('ee') >= 0 ) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'estonian'
    config.vod = false
    config.subDomain = 'ee'
    config.movies = true
    config.lang = 'ee'
    config.country = 'ee'
} else if (url.indexOf('gh') >= 0) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'gh'
    config.movies = true
    config.lang = 'en'
    config.country = 'gh'
} else if (url.indexOf('es') >= 0 ) { // only movies spanish
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'es';
    config.mainDomain = 'mobiotv'
    config.language = 'spanish'
    config.vod = false
    config.subDomain = 'es'
    config.lang = 'en',
    config.country = 'es'
} else if (url.indexOf('watch') >= 0 ) { // movies and videos
    config.smartTVshow = true,
    config.liveChannelshow = true,
    config.title = 'watch',
    config.mainDomain = ''
    config.language = 'english'
    config.vod = true
    config.subDomain = 'watch'
    config.lang = 'en'
    config.country = "xx"
} else if (url.indexOf('fr') >= 0) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'french'
    config.vod = false
    config.subDomain = 'fr'
    config.movies = true
    config.lang = 'fr'
    config.country = 'fr'
} else if (url.indexOf('vn') >= 0 ) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'Vietnamese'
    config.vod = false
    config.subDomain = 'vn'
    config.lang = 'en',
    config.country = 'vn'
} else if (url.indexOf('be') >= 0 ) {
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'be'
    config.movies = true
    config.lang = 'be'
    config.country = 'be'
} else if (url.indexOf('nl') >= 0 ) {
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'nl'
    config.movies = true
    config.lang = 'be';
    config.country = 'nl'
} else if (url.indexOf('ch.vidflixz') >= 0) {
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'german'
    config.vod = false
    config.subDomain = 'ch'
    config.movies = true
    config.newDomain = 'vidflixz'
    config.lang = (window.navigator.language && window.navigator.language.split('-')[0] === 'it') ? 'it' : (window.navigator.language && window.navigator.language.split('-')[0] === 'fr') ? 'fr' : 'de' 
    config.country = 'ch'
} else if (url.indexOf('id') >= 0 ) {
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'Indonesian'
    config.vod = true
    config.subDomain = 'id'
    config.movies = false
    config.lang = 'id'
    config.country = 'id'
} else if ((url.indexOf('it') >= 0 && url.indexOf('mobiofit') < 0)  ) {
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'italian'
    config.vod = false
    config.subDomain = 'it'
    config.movies = true
    config.lang = 'it'
    config.country = 'it'
}
else if (url.indexOf('sa.mobiofit') >= 0 ) { 
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'sa.mobiofit'
    config.movies = true
    config.lang = 'ar'
    config.country = 'sa'
} else if (url.indexOf('sa') >= 0 ) {
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'sa'
    config.movies = true
    config.lang = 'en'
    config.country = 'sa'
} else if (url.indexOf('tr.mobiofit') >= 0 ) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'tr.mobiofit'
    config.movies = true
    config.lang = 'tr'
    config.country = 'tr'
} else if (url.indexOf('ae.mobiofit') >= 0 ) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'ae.mobiofit'
    config.movies = true
    config.lang = 'en'
    config.country = 'ae'
} else if (url.indexOf('ae') >= 0 ) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'ae'
    config.movies = true
    config.lang = 'en'
    config.country = 'ae'    
} else if (url.indexOf('tr') >= 0) {
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'tr'
    config.movies = true
    config.lang = 'tr'
    config.country = 'tr'
} else if (url.indexOf('mh.telemovil') >= 0 ) {
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'mh'
    config.movies = true
    config.lang = 'en'
    config.newDomain = 'telemovil'
    config.country = 'xx'
} else if (url.indexOf('se') >= 0  ) {
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'Swedish'
    config.vod = false
    config.subDomain = 'se'
    config.movies = true
    config.lang = 'se'
    config.country = 'se'
} else if (url.indexOf('no.mobiofit') >= 0 ) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'norweigan'
    config.vod = false
    config.subDomain = 'no.mobiofit'
    config.movies = true
    config.lang = 'no',
    config.country = 'no'
} else if (url.indexOf('no') >= 0  ) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'norweigan'
    config.vod = false
    config.subDomain = 'no'
    config.movies = true
    config.lang = 'no',
    config.country = 'no'
} else if (url.indexOf('ke') >= 0 ) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'ke'
    config.movies = true
    config.lang = 'en'
    config.country = 'ke'
} else if (url.indexOf('sn') >= 0  ) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'french'
    config.vod = false
    config.subDomain = 'sn'
    config.movies = true
    config.lang = 'fr'
    config.country = 'sn'
} else if (url.indexOf('sg.mobiofit') >= 0 ) { 
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'sg.mobiofit'
    config.movies = true
    config.lang = 'en'
    config.country = 'sg'
}
else if (url.indexOf('kw.mobiofit') >= 0 ) { 
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'kw.mobiofit'
    config.movies = true
    config.lang = 'en'
    config.country = 'kw'
}
else if (url.indexOf('iq.mobiofit') >= 0 ) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'iq.mobiofit'
    config.movies = true
    config.lang = 'ar'
    config.country = 'iq'
} else if (url.indexOf('iq') >= 0) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'iq'
    config.movies = true
    config.lang = 'ar'
    config.country = 'iq'
} else if (url.indexOf('pk') >= 0 ) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'pk'
    config.movies = true
    config.lang = 'en'
    config.country = 'pk'
} else if (url.indexOf('lv') >= 0) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'lv'
    config.movies = true
    config.lang = 'lv'
    config.country = 'lv'
} else if (url.indexOf('lt') >= 0 ) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'lt'
    config.movies = true
    config.lang = 'lt'
    config.country = 'lt'
} else if (url.indexOf('maxis') >= 0 ) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'maxis'
    config.movies = true
    config.lang = 'en'
    config.country = 'my'
} else if (url.indexOf('my') >= 0 ) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'my'
    config.movies = true
    config.lang = 'en'
    config.country = 'my'
} else if (url.indexOf('th') >= 0) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'th'
    config.movies = true
    config.lang = 'th'
    config.country = 'th'
} else if (url.indexOf('bw') >= 0  ) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'bw'
    config.movies = true
    config.lang = 'en'
    config.country = 'bw'
}
else if (url.indexOf('rs.telemovil') >= 0 ) {
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.newDomain = 'telemovil'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'rs'
    config.movies = true
    config.lang = 'sr'
    config.country = 'rs'
} 
else if (url.indexOf('rs') >= 0 ) {
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'rs'
    config.movies = true
    config.lang = 'sr'
    config.country = 'rs'
}else if (url.indexOf('gr') >= 0 ) {
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'gr'
    config.movies = true
    config.lang = 'el'
    config.country = 'gr'
}else if (url.indexOf('ch') >= 0 ) {
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'german'
    config.vod = false
    config.subDomain = 'ch'
    config.movies = true
    config.lang = (window.navigator.language && window.navigator.language.split('-')[0] === 'it') ? 'it' : (window.navigator.language && window.navigator.language.split('-')[0] === 'fr') ? 'fr' : 'de' 
    config.country = 'ch'
}else if (url.indexOf('cz') >= 0 ) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'Czech'
    config.vod = false
    config.subDomain = 'cz'
    config.movies = true
    config.lang = 'cs'
    config.country = 'cz'
}else if (url.indexOf('ca') >= 0 ) { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'ca'
    config.movies = true
    config.lang = 'en'
    config.country = 'ca'
}else { // only videos
    config.smartTVshow = false;
    config.liveChannelshow = false;
    config.title = 'bidiotv';
    config.mainDomain = 'mobiotv'
    config.language = 'english'
    config.vod = false
    config.subDomain = 'my'
    config.movies = true
    config.lang = 'en'
    config.country='xx'
}


// WEBPACK FOOTER //
// ./src/constants/domainConfig.js